import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type { ReadingList } from '@efdigital/ll-addon-data/types/content/reading-list';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { query } from '@warp-drive/utilities/json-api';

interface QueryReadingListsOptions {
  scope?: string;
  clientId?: string;
}

/**
 * Query reading lists with filters
 * @param options - Query options including scope and clientId filters
 * @returns JSON API request to query reading lists
 */
export function queryReadingLists(options: QueryReadingListsOptions = {}) {
  const params: Record<string, string> = {};

  if (options.scope) {
    params['filter[scope]'] = options.scope;
  }

  if (options.clientId) {
    params['filter[client.id]'] = options.clientId;
  }

  if (options.scope || options.clientId) {
    params['include'] = 'resources';
  }

  return query<ReadingList>(DataTypeContent.ReadingList, params, {
    ...jsonApiOptions,
  });
}
